// import 'zone.js';// At the top of your main.ts file

declare function require(moduleName: string): any; // Only if TypeScript complains about require
// const settings = require('../activesetting/settings.js');
// import { ZoneContextManager } from 'aurelia-zone-manager';
import '@dynamik/common/styles/splash.scss';
import 'gridstack/dist/gridstack.min.css';
import { AureliaRouteContextManager } from './otel/route-context-manager';
import { Aurelia, LogManager } from 'aurelia-framework';
import { PLATFORM } from 'aurelia-pal';
import { HttpClient } from 'aurelia-fetch-client';
import { ConsoleAppender } from 'aurelia-logging-console';

import * as alc from 'aurelia-logging-console';
// !!!!!!!!!DO NOT REMOVE!!!!!!!! this forces the loading of the module which is removed for production build for unknown reasons
// eslint-disable-next-line @typescript-eslint/no-unused-expressions
alc;

import { enAU } from 'date-fns/locale/en-AU';
import { MdcDatepickerDialogConfiguration } from '@aurelia-toolkit/mdc-datepicker';
import { I18N } from 'aurelia-i18n';
import './extensions/binding-engine';
import './extensions/utc-date';
import './extensions/validation';
import './extensions/ag-grid-status-bar-patch';
import './extensions/aurelia';
import { LicenseManager } from 'ag-grid-enterprise';
import am4lang_en from '@amcharts/amcharts4/lang/en';
import { MdcComponentAdapters } from '@aurelia-mdc-web/base';
import { datepickerConfig } from './elements/mdc-daterange-picker/mdc-daterange-picker';
import './services/aurelia-typed-observable-fix';
import './extensions/inputmask';
import { HttpInterceptor403 } from './services/http-interceptor-403';
import { AureliaBatchSpanProcessor } from './otel/batch-span-processor';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { Resource } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions';
import { AlertConfiguration, AlertService, ExceptionsTracker } from '@aurelia-toolkit/alert';
import { OpenTelemetryExceptionsTracker } from './services/open-telemetry-exceptions-tracker';
import { ApiService, configure as dynConfigure } from '@dynamik/common';
import { addLicense } from '@amcharts/amcharts4/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { AlertModalDynamik } from './elements/dialogs/alert-modal/alert-modal';
import { PromptDialogDynamik } from './elements/dialogs/prompt-dialog/prompt-dialog';
import { loadApiConfig } from '@dynamik/common';

declare global {
  interface Window {
    ENVIRONMENT: string;
    TRACE_URL: string;
    LOG_LEVEL: string;
  }
}

export async function configure(aurelia: Aurelia) {
  await aurelia.container.get(ApiService).init();
  // Load API configuration from /config/* endpoints (feature environment)
  // This must be done before any API clients are instantiated
  await loadApiConfig();

  // await loadAndApplySettings();
  //   await loadSettings();

  LogManager.addAppender(new ConsoleAppender());
  LogManager.setLevel(parseInt(window.LOG_LEVEL));
  console.log(LogManager.getLevel())

  configureOpenTelemetry(aurelia);
  aurelia.use
    .standardConfiguration()
    .router()
    .feature(PLATFORM.moduleName('resources/index'))
    .globalResources([
      PLATFORM.moduleName('converters/abs-converter'),
      PLATFORM.moduleName('converters/names-filter'),
      PLATFORM.moduleName('converters/notification-type'),
      PLATFORM.moduleName('converters/file-sources'),
      PLATFORM.moduleName('converters/file-types'),
      PLATFORM.moduleName('converters/widget-name-cleanup'),
      PLATFORM.moduleName('elements/baloon/baloon'),
      PLATFORM.moduleName('elements/currency-lookup/currency-lookup'),
      PLATFORM.moduleName('elements/dialogs/alert-modal/alert-modal'),
      PLATFORM.moduleName('elements/dialogs/prompt-dialog/prompt-dialog'),
      PLATFORM.moduleName('elements/dialogs/two-field-prompt-dialog/two-field-prompt-dialog'),
      PLATFORM.moduleName('elements/dialogs/transactionCategoryDialog/transactionCategoryDialog'),
      PLATFORM.moduleName('elements/file/file'),
      PLATFORM.moduleName('elements/dyn-table/dyn-table'),
      PLATFORM.moduleName('elements/global-linear-progress/global-linear-progress'),
      PLATFORM.moduleName('elements/instrument-lookup/instrument-lookup'),
      PLATFORM.moduleName('elements/mdc-data-table-sort-header/mdc-data-table-sort-header'),
      PLATFORM.moduleName('elements/mdc-daterange-picker/mdc-daterange-picker'),
      PLATFORM.moduleName('elements/numbers/twoDecimalRender'),
      PLATFORM.moduleName('elements/numbers/fourDecimalRender'),
      PLATFORM.moduleName('elements/table-with-toolbar/table-with-toolbar'),
      PLATFORM.moduleName('elements/portfolio-selector/portfolio-selector'),
      PLATFORM.moduleName('elements/price-history-by-date/price-history-by-date'),
      PLATFORM.moduleName('elements/reporting-overview/reporting-overview'),
      PLATFORM.moduleName('elements/reports/balance-sheet-report/balance-sheet-report'),
      PLATFORM.moduleName('elements/reports/profit-loss-report/profit-loss-report'),
      PLATFORM.moduleName('elements/numbers/number-field/number-field'),
      PLATFORM.moduleName('elements/promise-resolver/promise-resolver'),
      PLATFORM.moduleName('elements/report-page/report-page'),
      PLATFORM.moduleName('elements/report-widget-properties/report-widget-properties'),
      PLATFORM.moduleName('elements/report-widgets/balance-sheet-widget/balance-sheet-widget'),
      PLATFORM.moduleName('elements/report-widgets/breakdown-per-dimension-widget/breakdown-per-dimension-widget'),
      PLATFORM.moduleName('elements/report-widgets/customer-totals-widget/customer-totals-widget'),
      PLATFORM.moduleName('elements/report-widgets/nav-change-widget/nav-change-widget'),
      PLATFORM.moduleName('elements/report-widgets/nav-details-widget/nav-details-widget'),
      PLATFORM.moduleName('elements/report-widgets/nav-key-figures-widget/nav-key-figures-widget'),
      PLATFORM.moduleName('elements/report-widgets/nokkeltall-widget/nokkeltall-widget'),
      PLATFORM.moduleName('elements/report-widgets/portfolio-by-type-widget/portfolio-by-type-widget'),
      PLATFORM.moduleName('elements/report-widgets/portfolio-overview-by-type-light-widget/portfolio-overview-by-type-light-widget'),
      PLATFORM.moduleName('elements/report-widgets/portfolio-overview-by-type-widget/portfolio-overview-by-type-widget'),
      PLATFORM.moduleName('elements/report-widgets/portfolio-overview-chart-widget/portfolio-overview-chart-widget'),
      PLATFORM.moduleName('elements/report-widgets/portfolio-overview-chart-new-widget/portfolio-overview-chart-new-widget'),
      PLATFORM.moduleName('elements/report-widgets/portfolio-overview-light-widget/portfolio-overview-light-widget'),
      PLATFORM.moduleName('elements/report-widgets/portfolio-overview-light-experimental-widget/portfolio-overview-light-experimental-widget'),
      PLATFORM.moduleName('elements/report-widgets/portfolio-overview-widget/portfolio-overview-widget'),
      PLATFORM.moduleName('elements/report-widgets/portfolio-period-widget/portfolio-period-widget'),
      PLATFORM.moduleName('elements/report-widgets/profit-loss-period-widget/profit-loss-period-widget'),
      PLATFORM.moduleName('elements/report-widgets/processed-vouchers-light-widget/processed-vouchers-light-widget'),
      PLATFORM.moduleName('elements/report-widgets/cost-breakdown-widget/cost-breakdown-widget'),
      PLATFORM.moduleName('elements/report-widgets/processed-vouchers-widget/processed-vouchers-widget'),
      PLATFORM.moduleName('elements/report-widgets/profit-loss-widget/profit-loss-widget'),
      PLATFORM.moduleName('elements/report-widgets/page-number-widget/page-number-widget'),
      PLATFORM.moduleName('elements/report-widgets/top-bottom-instruments-light-widget/top-bottom-instruments-light-widget'),
      PLATFORM.moduleName('elements/report-widgets/top-bottom-instruments-widget/top-bottom-instruments-widget'),
      PLATFORM.moduleName('elements/report-widgets/total-profit-loss-widget/total-profit-loss-widget'),
      PLATFORM.moduleName('elements/report-widgets/value-adjustment-widget/value-adjustment-widget'),
      PLATFORM.moduleName('elements/report-widgets/unconverted-instruments-widget/unconverted-instruments-widget'),
      PLATFORM.moduleName('elements/report-widgets/welcome-widget/welcome-widget'),
      PLATFORM.moduleName('elements/selects/transaction-categories-lookup/transaction-categories-lookup'),
      PLATFORM.moduleName('elements/statuses/check-icon/check-icon'),
      PLATFORM.moduleName('elements/theme-selector/theme-selector'),
      PLATFORM.moduleName('elements/voucher-graph/voucher-graph'),
      PLATFORM.moduleName('elements/wizard-steps/wizard-steps'),
      PLATFORM.moduleName('agElements/editors/agDateEditor'),
      PLATFORM.moduleName('agElements/editors/agNumericEditor'),
      PLATFORM.moduleName('agElements/editors/agPriceEditor'),
      PLATFORM.moduleName('agElements/editors/ag-from-date-range-editor/ag-from-date-range-editor'),
      PLATFORM.moduleName('agElements/iconButtons/deleteButton/deleteButton'),
      PLATFORM.moduleName('agElements/overview-aggregation-component/overview-aggregation-component'),
      PLATFORM.moduleName('views/corporations/dialogs/add-company-dialog/add-company-dialog'),
      PLATFORM.moduleName('views/corporations/dialogs/assign-user-dialog/assign-user-dialog'),
      PLATFORM.moduleName('views/corporations/dialogs/create-corporation-dialog/create-corporation-dialog'),
    ]);

  aurelia.use
    .plugin(PLATFORM.moduleName('@aurelia-mdc-web/all'))
    .plugin(dynConfigure)
    .plugin(PLATFORM.moduleName('aurelia-gridstack'))
    .plugin(PLATFORM.moduleName('aurelia-i18n'), async (instance: I18N) => {
      await instance.setup();
      instance.i18next.addResourceBundle('en', 'aurelia-toolkit', { alert: { error: 'Error' } }, true, false);
    })
    .plugin(PLATFORM.moduleName('aurelia-inputmask'), { showMaskOnHover: false })
    .plugin(PLATFORM.moduleName('aurelia-split-pane'))
    .plugin(PLATFORM.moduleName('aurelia-validation'))
    .plugin(PLATFORM.moduleName('bcx-aurelia-reorderable-repeat'))
    .plugin(PLATFORM.moduleName('@aurelia-toolkit/alert'), (c: AlertConfiguration) => {
      c.defaultAlertModal = AlertModalDynamik;
      c.defaultPromptDialog = PromptDialogDynamik;
    })
    .plugin(PLATFORM.moduleName('@aurelia-toolkit/form-field'))
    .plugin(PLATFORM.moduleName('@aurelia-toolkit/mdc-inputmask'))
    .plugin(PLATFORM.moduleName('@aurelia-toolkit/mdc-datepicker'), (c: MdcDatepickerDialogConfiguration) => {
      c.defaultOptions.i18n.dateFnsLocale = enAU;
      c.defaultOptions.firstDay = 1;
    });

  configureHttp(aurelia);

  aurelia.use.plugin(PLATFORM.moduleName('ag-grid-aurelia'));

  await aurelia.start();

  aurelia.container.get(AureliaRouteContextManager).enable();
  aurelia.setRoot(PLATFORM.moduleName('views/app/app'));
  aurelia.container.get(MdcComponentAdapters).registerMdcElementConfig(datepickerConfig);
}

function configureOpenTelemetry(aurelia: Aurelia) {
  if (!window.TRACE_URL) {
    return;
  }
  aurelia.container.registerInstance(AureliaRouteContextManager, new AureliaRouteContextManager());
  const exporter = new OTLPTraceExporter({ url: `${window.TRACE_URL}` });
  aurelia.container.registerInstance(AureliaBatchSpanProcessor, new AureliaBatchSpanProcessor(exporter));
  const provider = new WebTracerProvider({
    resource: new Resource({
      [ATTR_SERVICE_NAME]: 'Aurelia',
      ["Browser.screen.width"]: `${screen.width}x${screen.height}`
    }),
    spanProcessors: [aurelia.container.get(AureliaBatchSpanProcessor)]
  });

  provider.register({
    contextManager: aurelia.container.get(AureliaRouteContextManager)
  });

  registerInstrumentations({
    instrumentations: [
      // new UserInteractionInstrumentation(),
      // new FetchInstrumentation({
      //     propagateTraceHeaderCorsUrls: window.TRACE_URL,
      //
      //     ignoreNetworkEvents: false,
      //     applyCustomAttributesOnSpan: (span, request, result) => {
      //         span.updateName(`${request.method} ${request instanceof Request ? request.url : result instanceof Response ? result.url : ''}`);
      //         span.setAttribute('Browser.window.innerWidth', window.innerWidth);
      //         span.setAttribute('Browser.window.innerHeight', window.innerHeight);
      //         span.setAttribute('Browser.window.innerRes', `${window.innerWidth}x${window.innerHeight}`);
      //     }
      // }),
    ]
  });
  aurelia.container.registerInstance(ExceptionsTracker, new OpenTelemetryExceptionsTracker());
}

function configureHttp(aurelia: Aurelia) {

  const httpClient = aurelia.container.get(HttpClient);
  httpClient.configure(x =>
    x
      .withDefaults({ credentials: 'include' })
      .withInterceptor({
        response: (response, request) => {
          response.traceParent = request.headers.get('Traceparent');
          return response;
        }
      })
      .withInterceptor({
        response: async (response) => {
          if (response.status === 401) {
            var alertService = aurelia.container.get(AlertService);
            await alertService.error({ html: 'You have been logged out because of inactivity.<br>Please log in again.' });
            window.location.reload();
          }
          return response;
        }
      })
      .withInterceptor(aurelia.container.get(HttpInterceptor403))
  );
}

LicenseManager.setLicenseKey('Using_this_AG_Grid_Enterprise_key_( AG-049987 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Dynamik Management AS )_is_granted_a_( Single Application )_Developer_License_for_the_application_( DYNAMIK Insight )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( DYNAMIK Insight )_need_to_be_licensed___( DYNAMIK Insight )_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 30 November 2024 )____[v2]_MTczMjkyNDgwMDAwMA==84bb3b1ee9e6ec676c9ccb4fb7f3216d');
addLicense("CH444904835");

am4lang_en["_big_number_suffix_9"] = 'B';



